import { createAsyncThunk } from "@reduxjs/toolkit";
import { OrderReportState } from "./types";
import axios from "axios";
import { getToken } from "src/helper/generalFunction";

export interface ListOrderProps {
  offset?: number;
  limit?: number;
  status_order?: string;
  start_date?: any;
  end_date?: any;
  store_id?: string;
  product_type?: string;
  cashier_name?: string;
}

export const getList = createAsyncThunk(
  "orderReport/list",
  async (props: ListOrderProps) => {
    const config = {
      headers: {
        api_key: "Basic 15cb7ebf9-3dcc-h28s-b056-2522c1eed03e",
        token: getToken(),
      },
    };
    let url = `/merchant/order/reports/data?limit=${props.limit}&offset=${
      props.offset
    }${props.status_order ? `&status_order=${props.status_order}` : ""}${
      props.start_date ? `&start_date=${props.start_date}` : ""
    }${props.end_date ? `&end_date=${props.end_date}` : ""}${
      props.store_id && props.store_id !== "0"
        ? `&store_id=${props.store_id}`
        : ""
    }${props.product_type ? `&product_type=${props.product_type}` : ""}${
      props.cashier_name ? `&cashier_name=${encodeURIComponent(props.cashier_name)}` : ""
    }`;

    console.log("Fetching orders from URL:", url);

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}${url}`,
        config
      );
      console.log("Order API response:", response.data);
      if (response && response.data) {
        return {
          data: response.data,
          status: "success",
          error: null,
        } as unknown as OrderReportState;
      } else {
        return {
          data: response.data?.message,
          status: "empty",
          error: null,
        } as unknown as OrderReportState;
      }
    } catch (err) {
      console.error("Error in getList:", err);
      return {
        data: "Something went wrong!",
        status: "error",
        error: err,
      } as unknown as OrderReportState;
    }
  }
);

export interface downloadOrderProps {
  status_order?: string;
  start_date?: any;
  end_date?: any;
  store_id?: string;
  cashier_name?: string;
}

export const downloadReport = createAsyncThunk(
  "orderReport/download",
  async (props: downloadOrderProps) => {
    const config = {
      headers: {
        api_key: "Basic 15cb7ebf9-3dcc-h28s-b056-2522c1eed03e",
        token: getToken(),
      },
    };
    let url = `/merchant/order/reports/data/download?${
      props.status_order ? `&status_order=${props.status_order}` : ""
    }${props.start_date ? `&start_date=${props.start_date}` : ""}${
      props.end_date ? `&end_date=${props.end_date}` : ""}${
      props.store_id && props.store_id !== "0"
        ? `&store_id=${props.store_id}`
        : ""
    }${props.cashier_name ? `&cashier_name=${encodeURIComponent(props.cashier_name)}` : ""}`;

    console.log("Downloading report from URL:", url);

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}${url}`,
        config
      );
      if (response && response.data) {
        return {
          data: response.data,
          status: "success",
          error: null,
        } as unknown as OrderReportState;
      } else {
        return {
          data: response.data?.message,
          status: "empty",
          error: null,
        } as unknown as OrderReportState;
      }
    } catch (err) {
      console.error("Error in downloadReport:", err);
      return {
        data: "Something went wrong!",
        status: "error",
        error: err,
      } as unknown as OrderReportState;
    }
  }
);
